import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { CustomerState } from '@/store/modules/backoffice/customer/index';
import {
  ALL_CUSTOMERS,
  ALL_CUSTOMERS_ERRORS,
  ALL_OFFICES_BY_CUSTOMER,
  ALL_OFFICES_ERRORS,
  ALL_REMINDERS_BY_CUSTOMER,
  ALL_SECTIONS_BY_OFFICE,
  CUSTOMER_DETAILS,
  EXPORT_FORM_101_REQUEST_ERROR,
  MANAGER_PRIVILEGES,
  MANAGER_TO_ADD,
  MANAGER_TO_DELETE,
  MANAGER_TO_UPDATE,
  MANAGERS_BY_CUSTOMER,
  OFFICE_DETAILS,
  OPEN_ADD_MANAGER_MODAL,
  OPEN_ADD_MANAGER_MODAL_ERRORS,
  OPEN_CREATE_REMINDERS_MODAL,
  OPEN_CREATE_REMINDERS_MODAL_ERRORS,
  OPEN_DELETE_MANAGER_MODAL,
  OPEN_DELETE_MANAGER_MODAL_ERRORS,
  OPEN_UPDATE_MANAGER_MODAL,
  OPEN_UPDATE_MANAGER_MODAL_ERRORS,
  OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL,
  OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS,
  ORG_UNITS,
  UPDATE_CUSTOMER_SETTINGS_MODAL,
  UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS,
  UPDATE_OFFICE_SETTINGS_MODAL,
  UPDATE_OFFICE_SETTINGS_MODAL_ERRORS,
} from '@/types/customer.types';
import { Grid } from '@/models/Grid.model';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { ManagerPrivilegesModel } from '@/models/backoffice/ManagerPrivilegesModel';
import { SearchManagerModel } from '@/models/backoffice/SearchManagerModel';
import { OrganisationUnitModel } from '@/models/backoffice/OrganisationUnitModel';

export const getters: GetterTree<CustomerState, RootState> = {

  [ALL_CUSTOMERS](state): Grid {
    return state.allCustomers;
  },

  [ALL_CUSTOMERS_ERRORS](state): string[] {
    return state.allCustomersErrors;
  },

  [CUSTOMER_DETAILS](state): CustomerDetailsModel {
    return state.customerDetails;
  },

  [UPDATE_CUSTOMER_SETTINGS_MODAL](state): boolean {
    return state.updateCustomerSettingsModal;
  },

  [UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS](state): string[] {
    return state.updateCustomerSettingsModalErrors;
  },

  [ALL_OFFICES_BY_CUSTOMER](state): Grid {
    return state.allOfficesByCustomer;
  },

  [ALL_OFFICES_ERRORS](state): string[] {
    return state.allOfficesErrors;
  },

  [ALL_SECTIONS_BY_OFFICE](state): Grid {
    return state.allSectionsByOffice;
  },

  [OFFICE_DETAILS](state): CustomerDetailsModel {
    return state.officeDetails;
  },

  [UPDATE_OFFICE_SETTINGS_MODAL](state): boolean {
    return state.updateOfficeSettingsModal;
  },

  [UPDATE_OFFICE_SETTINGS_MODAL_ERRORS](state): string[] {
    return state.updateOfficeSettingsModalErrors;
  },

  [ALL_REMINDERS_BY_CUSTOMER](state): Grid {
    return state.allRemindersByCustomer;
  },

  [OPEN_CREATE_REMINDERS_MODAL](state): boolean {
    return state.openCreateRemindersModal;
  },

  [OPEN_CREATE_REMINDERS_MODAL_ERRORS](state): string[] {
    return state.openCreateRemindersModalErrors;
  },

  [MANAGERS_BY_CUSTOMER](state): Grid {
    return state.managersByCustomer;
  },

  [MANAGER_TO_ADD](state): Grid {
    return state.managerToAdd;
  },

  [MANAGER_TO_DELETE](state): ManagerPrivilegesModel | null {
    return state.managerToDelete;
  },

  [OPEN_DELETE_MANAGER_MODAL](state): boolean {
    return state.openDeleteManagerModal;
  },

  [OPEN_DELETE_MANAGER_MODAL_ERRORS](state): string[] {
    return state.openDeleteManagerModalErrors;
  },

  [MANAGER_TO_UPDATE](state): ManagerPrivilegesModel | null {
    return state.managerToUpdate;
  },

  [OPEN_UPDATE_MANAGER_MODAL](state): boolean {
    return state.openUpdateManagerModal;
  },

  [OPEN_UPDATE_MANAGER_MODAL_ERRORS](state): string[] {
    return state.openUpdateManagerModalErrors;
  },
  [OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL](state): boolean {
    return state.openUploadManagerPrivilegesModal;
  },

  [OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS](state): string[] {
    return state.openUploadManagerPrivilegesModalErrors;
  },

  [OPEN_ADD_MANAGER_MODAL](state): boolean {
    return state.openAddManagerModal;
  },

  [OPEN_ADD_MANAGER_MODAL_ERRORS](state): string[] {
    return state.openAddManagerModalErrors;
  },

  [ORG_UNITS](state): OrganisationUnitModel[] {
    return state.orgUnits;
  },

  [MANAGER_PRIVILEGES](state): any {
    return state.managerPrivileges;
  },

  [EXPORT_FORM_101_REQUEST_ERROR](state): any {
    return state.exportForm101Errors;
  },

};
